import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../nativeComms";

const openUrl = url => {
  if (isNativeCommsInstalled()) {
    // Tell the native app to open the URL
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.OPEN_EXTERNAL_LINK,
      path: url
    });
  } else {
    // Open the URL in the browser
    window.open(url, "_blank").focus();
  }
};

export default openUrl;
